'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllAgentResponders = undefined;

var _getters = require('conversations-async-data/async-data/operators/getters');

var _getters2 = require('conversations-async-data/indexed-async-data/operators/getters');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _reselect = require('reselect');

var _filter = require('transmute/filter');

var _filter2 = _interopRequireDefault(_filter);

var _map = require('transmute/map');

var _map2 = _interopRequireDefault(_map);

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _responderKeyGetters = require('../operators/responderKeyGetters');

var _getResponders = require('./getResponders');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAllAgentResponders = exports.getAllAgentResponders = (0, _reselect.createSelector)([_getResponders.getResponders], function (respondersAsyncData) {
  return (0, _pipe2.default)(_getters2.getEntries, (0, _filter2.default)(function (__value, key) {
    return (0, _responderKeyGetters.getType)(key) === _senderTypes.AGENT;
  }), (0, _map2.default)(_getters.getData))(respondersAsyncData);
});